/**
 * Validadores de input — espejo de las reglas del backend
 * (backend/app/blueprints/auth/schemas.py).
 *
 * Mantener sincronizado: si cambian los regex/longitudes en backend,
 * actualizar aquí también. Validación frontend es UX-friendly; backend
 * es source of truth de seguridad.
 */

const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const MIN_PASSWORD_LEN = 8;
export const MAX_PASSWORD_LEN = 256;
export const MAX_EMAIL_LEN = 254;
export const MAX_FULL_NAME_LEN = 120;
// Sprint 7 Bloque B1: charset y longitud del invite_code (espejo de
// backend/app/blueprints/auth/invite_codes.py).
export const MAX_INVITE_CODE_LEN = 32;
const INVITE_CODE_RE = /^[A-Z0-9_-]{1,32}$/;

export type FieldError = {
  field: string;
  code: string;
};

export function validateEmail(value: string): FieldError | null {
  const v = value.trim().toLowerCase();
  if (!v) return { field: "email", code: "email_required" };
  if (v.length > MAX_EMAIL_LEN) return { field: "email", code: "email_too_long" };
  if (!EMAIL_RE.test(v)) return { field: "email", code: "email_invalid" };
  return null;
}

export function validatePassword(value: string): FieldError | null {
  if (!value) return { field: "password", code: "password_required" };
  if (value.length < MIN_PASSWORD_LEN)
    return { field: "password", code: "password_too_short" };
  if (value.length > MAX_PASSWORD_LEN)
    return { field: "password", code: "password_too_long" };
  return null;
}

export function validateFullName(value: string): FieldError | null {
  // Opcional — si está vacío es válido.
  if (!value) return null;
  if (value.length > MAX_FULL_NAME_LEN)
    return { field: "full_name", code: "full_name_too_long" };
  return null;
}

export function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}

/**
 * Validador cliente del invite_code (Sprint 7 Bloque B1).
 *
 * El backend hace el lookup definitivo y conoce la lista real; este
 * validador solo bloquea inputs sintácticamente imposibles (vacío,
 * demasiado largo) para evitar request basura. El uppercase ya lo hace
 * el input UI mientras escribes; aquí validamos sobre el valor que
 * llegaría al backend.
 */
export function validateInviteCode(value: string): FieldError | null {
  const v = value.trim().toUpperCase();
  if (!v) return { field: "invite_code", code: "invite_code_required" };
  if (v.length > MAX_INVITE_CODE_LEN)
    return { field: "invite_code", code: "invite_code_invalid" };
  if (!INVITE_CODE_RE.test(v))
    return { field: "invite_code", code: "invite_code_invalid" };
  return null;
}

export function normalizeInviteCode(value: string): string {
  return value.trim().toUpperCase();
}
